import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MP',
  engine: 'createJS',
  gameConfig: dataConfig,
  title: [
    {
      text: 'Które obrazki nie są ikonami komputerowymi? Umieść je w koszu metodą <i>złap, przesuń i upuść</i>.',
      audio: 'games/page006_game1/audio/z6c1-1.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page006_game1/audio/z6c1-brawo.mp3',
    // negative: 'games/page001_game1/audio/z1c1-brawo.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo! ',
    negative: '',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
